<template>
  <news-create-form :id="id" :editMode="true"></news-create-form>
</template>

<script>
import NewsCreateForm from "./CreateForm";
export default {
  name: "CreateNewPage",
  components: { NewsCreateForm },
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = this.$route.params.id;
  }
};
</script>

<style scoped></style>
